import { render } from "./ButtonRadio.vue?vue&type=template&id=c38d8852&scoped=true"
import script from "./ButtonRadio.vue?vue&type=script&lang=js"
export * from "./ButtonRadio.vue?vue&type=script&lang=js"

import "./ButtonRadio.vue?vue&type=style&index=0&id=c38d8852&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c38d8852"]])

export default __exports__